import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';
import ButtonsGroup from 'components/molecules/ButtonsGroup/ButtonsGroup';
import Paragraph from 'components/atoms/Paragraph/Paragraph';

export default function DetailsGroup(props) {
  const [detailGroupValue, setDetailGroupValue] = useState(0);

  const {
    leftGroupName,
    rightGroupName,
    leftGroupContent,
    rightGroupContent,
  } = props;
  return (
    <Box>
      <ButtonsGroup
        label1={leftGroupName}
        label2={rightGroupName}
        onButtonClick={setDetailGroupValue}
      />
      <Box mb={2}>
        <Paragraph>
          {detailGroupValue === 0 ? leftGroupContent : rightGroupContent}
        </Paragraph>
      </Box>
    </Box>
  );
}

DetailsGroup.propTypes = {};
